export const ONBOARDING_PRESENCE_PAGE_STATE_KEYS = {
	PRESENCE_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN: 'page:pagePresenceAvatarGroupSpotlightSeen',
	TELEPOINTER_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN: 'page:pageTelepointerAvatarGroupSpotlightSeen',
};
